import React from 'react';

const LocationsEmptySection = () => {
  return <div className={'d-flex justify-content-center text-muted m-5'} name={'locations-empty-section'} >
    No locations provided, click on
    <b className={'mx-2'} name={'add-more-locations-text'}>+ Add more locations</b>
    to add a new one
  </div>;
};

export default LocationsEmptySection;
